
import React, { useEffect, useState } from "react";

import bannerImage from "../../../images/banner1.jpg";
import omniscanLogo from "../../../images/logo_white.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
    faChartLine,
    faArrowUpRightFromSquare,
    faArrowRight,
    faGears,
    faBuilding,
    faGaugeHigh,
    faSliders,
    faStar,
    faCircleCheck,
    faXmark
} from "@fortawesome/free-solid-svg-icons";

import {
    faCirclePlay
} from "@fortawesome/free-regular-svg-icons";

import {
    functions
} from "../../constants/common-functions";

import "./OmniScanEntry.css";


//========================================================
// OMNISCAN PRO
// ENTRY SCREEN
//========================================================

export default function OmniScanEntry({ onEnter })
{
    //====================================================
    // Configuration
    //====================================================

    const ABOUT_PRESENTATION_URL =
        process.env.PUBLIC_URL +
        "https://websites.omniscanpro.com/html/about/introduction.html";

    const WEBSITE_URL =
        "https://www.omniscanpro.com";

    const CLIENT_PRESENTATION_URL =
        "https://presentations.omniscanpro.com/client_proposal";


    //====================================================
    // State
    //====================================================

    const [showAbout, setShowAbout] =
        useState(false);

    const [showPreferences, setShowPreferences] =
        useState(false);


    //====================================================
    // Demo Detection
    //====================================================

    const isDemo =
        functions.getIsDemoSystem() === true;


    //====================================================
    // Modal Actions
    //====================================================

    const openAbout = () =>
    {
        setShowPreferences(false);
        setShowAbout(true);
    };

    const closeAbout = () =>
    {
        setShowAbout(false);
    };

    const openPreferences = () =>
    {
        setShowAbout(false);
        setShowPreferences(true);
    };

    const closePreferences = () =>
    {
        setShowPreferences(false);
    };


    //====================================================
    // External Links
    //====================================================

    const openExternalLink = (url) =>
    {
        window.open(
            url,
            "_blank",
            "noopener,noreferrer"
        );
    };


    //====================================================
    // Escape Key / Modal Scroll Lock
    //====================================================

    useEffect(
        () =>
        {
            if (!showAbout && !showPreferences)
            {
                return;
            }

            const handleKeyDown = (event) =>
            {
                if (event.key === "Escape")
                {
                    closeAbout();
                    closePreferences();
                }
            };

            const previousOverflow =
                document.body.style.overflow;

            document.body.style.overflow = "hidden";

            window.addEventListener(
                "keydown",
                handleKeyDown
            );

            return () =>
            {
                document.body.style.overflow =
                    previousOverflow;

                window.removeEventListener(
                    "keydown",
                    handleKeyDown
                );
            };
        },
        [showAbout, showPreferences]
    );


    //====================================================
    // Preference Preview Items
    //====================================================

    const preferenceItems =
    [
        {
            icon: faBuilding,
            title: "Favourite Buildings",
            description:
                "Choose your favourite properties and buildings for quick access."
        },
        {
            icon: faGaugeHigh,
            title: "My Dashboards",
            description:
                "Personalise the dashboards and intelligence you see first."
        },
        {
            icon: faStar,
            title: "My Favourites",
            description:
                "Keep your frequently used locations, information and documents close at hand."
        },
        {
            icon: faSliders,
            title: "My Preferences",
            description:
                "Set your preferred views, defaults and workspace experience."
        }
    ];


    //====================================================
    // Render
    //====================================================

    return (

        <div
            className="omniscan-entry"
            style={{
                backgroundImage: `url(${bannerImage})`
            }}
        >

            {/*==========================================
                BACKGROUND OVERLAY
            ==========================================*/}

            <div className="omniscan-entry-overlay" />


            {/*==========================================
                HEADER
            ==========================================*/}

            <header className="omniscan-entry-header">

                <img
                    src={omniscanLogo}
                    alt="OmniScanPro"
                    className="omniscan-entry-logo"
                />

            </header>


            {/*==========================================
                MAIN CONTENT
            ==========================================*/}

            <main className="omniscan-entry-content">

                <div className="omniscan-entry-eyebrow">
                    OMNISCAN PRO
                </div>

                <h1 className="omniscan-entry-title">
                    Property Intelligence Hub
                </h1>

                <p className="omniscan-entry-tagline">
                    Your properties. Your information. Your way.
                </p>


                {/*======================================
                    PRIMARY NAVIGATION
                ======================================*/}

                <div className="omniscan-entry-cards">


                    {/*==================================
                        ENTER OMNISCAN
                    ==================================*/}

                    <button
                        type="button"
                        className="omniscan-entry-card"
                        onClick={onEnter}
                    >

                        <div className="omniscan-entry-card-top">

                            <FontAwesomeIcon
                                icon={faChartLine}
                                aria-hidden="true"
                            />

                            <FontAwesomeIcon
                                icon={faArrowUpRightFromSquare}
                                className="omniscan-entry-card-arrow"
                                aria-hidden="true"
                            />

                        </div>

                        <div className="omniscan-entry-card-bottom">

                            <span className="omniscan-entry-card-title">
                                ENTER OMNISCAN
                            </span>

                            <span className="omniscan-entry-card-description">
                                Data, Documents and Delivery
                            </span>

                        </div>

                    </button>


                    {/*==================================
                        MY OMNISCAN
                    ==================================*/}

                    <button
                        type="button"
                        className="omniscan-entry-card"
                        onClick={openPreferences}
                    >

                        <div className="omniscan-entry-card-top">

                            <FontAwesomeIcon
                                icon={faGears}
                                aria-hidden="true"
                            />

                            <FontAwesomeIcon
                                icon={faArrowUpRightFromSquare}
                                className="omniscan-entry-card-arrow"
                                aria-hidden="true"
                            />

                        </div>

                        <div className="omniscan-entry-card-bottom">

                            <span className="omniscan-entry-card-title">
                                MY OMNISCAN
                            </span>

                            <span className="omniscan-entry-card-description">
                                Your workspace. Your preferences.
                            </span>

                        </div>

                    </button>

                </div>


                {/*======================================
                    ABOUT OMNISCAN
                ======================================*/}

                <button
                    type="button"
                    className="omniscan-entry-discover"
                    onClick={openAbout}
                >

                    <FontAwesomeIcon
                        icon={faCirclePlay}
                        aria-hidden="true"
                    />

                    <span>
                        ABOUT OMNISCAN
                    </span>

                    <FontAwesomeIcon
                        icon={faArrowRight}
                        aria-hidden="true"
                    />

                </button>

            </main>


            {/*==========================================
                FOOTER
            ==========================================*/}

            <footer className="omniscan-entry-footer">
                PROPERTY INTELLIGENCE. CONNECTED.
            </footer>


            {/*==========================================
                RIGHT-HAND LINKS
            ==========================================*/}

            <div className="omniscan-entry-external-links">

                <button
                    type="button"
                    className="omniscan-entry-website-link"
                    onClick={() =>
                        openExternalLink(WEBSITE_URL)
                    }
                    title="Open OmniScan Pro Website"
                >
                    <span>WEBSITE</span>

                    <span
                        className="omniscan-entry-website-arrow"
                        aria-hidden="true"
                    >
                        ↗
                    </span>
                </button>

                {isDemo && (

                    <button
                        type="button"
                        className="omniscan-entry-website-link"
                        onClick={() =>
                            openExternalLink(CLIENT_PRESENTATION_URL)
                        }
                        title="Open Client Introduction"
                    >
                        <span>CLIENT INTRODUCTION</span>

                        <span
                            className="omniscan-entry-website-arrow"
                            aria-hidden="true"
                        >
                            ↗
                        </span>
                    </button>

                )}

            </div>


            {/*==========================================
                ABOUT PRESENTATION OVERLAY
            ==========================================*/}

            {showAbout && (

                <div
                    className="omniscan-entry-about-overlay"
                    onClick={closeAbout}
                >

                    <div
                        className="omniscan-entry-about-window"
                        role="dialog"
                        aria-modal="true"
                        aria-label="About OmniScan"
                        onClick={(event) =>
                            event.stopPropagation()
                        }
                    >

                        <div className="omniscan-entry-about-header">

                            <div className="omniscan-entry-about-heading">

                                <span className="omniscan-entry-about-kicker">
                                    OMNISCAN PRO
                                </span>

                                <span className="omniscan-entry-about-title">
                                    About OmniScan
                                </span>

                            </div>

                            <button
                                type="button"
                                className="omniscan-entry-about-close"
                                onClick={closeAbout}
                                aria-label="Close About OmniScan"
                            >
                                ×
                            </button>

                        </div>

                        <div className="omniscan-entry-about-body">

                            <iframe
                                title="About OmniScan Presentation"
                                src={ABOUT_PRESENTATION_URL}
                                className="omniscan-entry-about-frame"
                                allowFullScreen
                            />

                        </div>

                    </div>

                </div>

            )}


            {/*==========================================
                MY OMNISCAN GLASS POPUP
            ==========================================*/}

            {showPreferences && (

                <div
                    className="omniscan-entry-preferences-overlay"
                    onClick={closePreferences}
                >

                    <div
                        className="omniscan-entry-preferences-window"
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="omniscan-preferences-title"
                        onClick={(event) =>
                            event.stopPropagation()
                        }
                    >

                        {/*==============================
                            HEADER
                        ==============================*/}

                        <div className="omniscan-entry-preferences-header">

                            <div className="omniscan-entry-preferences-heading">

                                <span className="omniscan-entry-about-kicker">
                                    YOUR PERSONALISED WORKSPACE
                                </span>

                                <h2 id="omniscan-preferences-title">
                                    My OmniScan
                                </h2>

                            </div>

                            <button
                                type="button"
                                className="omniscan-entry-preferences-close"
                                onClick={closePreferences}
                                aria-label="Close My OmniScan"
                            >
                                <FontAwesomeIcon icon={faXmark} />
                            </button>

                        </div>


                        {/*==============================
                            INTRODUCTION
                        ==============================*/}

                        <div className="omniscan-entry-preferences-intro">

                            <div className="omniscan-entry-preferences-hero-icon">
                                <FontAwesomeIcon icon={faGears} />
                            </div>

                            <div>

                                <h3>
                                    Make OmniScan yours.
                                </h3>

                                <p>
                                    Your properties. Your information.
                                    Your way. My OmniScan will give you
                                    control over how you navigate,
                                    explore and experience your
                                    property intelligence.
                                </p>

                            </div>

                        </div>


                        {/*==============================
                            PREFERENCE OPTIONS
                        ==============================*/}

                        <div className="omniscan-entry-preferences-grid">

                            {preferenceItems.map((item) => (

                                <div
                                    className="omniscan-entry-preference-item"
                                    key={item.title}
                                >

                                    <div className="omniscan-entry-preference-icon">

                                        <FontAwesomeIcon
                                            icon={item.icon}
                                            aria-hidden="true"
                                        />

                                    </div>

                                    <div className="omniscan-entry-preference-copy">

                                        <h4>{item.title}</h4>

                                        <p>{item.description}</p>

                                    </div>

                                </div>

                            ))}

                        </div>


                        {/*==============================
                            COMING SOON FOOTER
                        ==============================*/}

                        <div className="omniscan-entry-preferences-footer">

                            <div className="omniscan-entry-preferences-status">

                                <FontAwesomeIcon
                                    icon={faCircleCheck}
                                    aria-hidden="true"
                                />

                                <span>
                                    Personalisation features coming soon
                                </span>

                            </div>

                            <button
                                type="button"
                                className="omniscan-entry-preferences-done"
                                onClick={closePreferences}
                            >
                                GOT IT

                                <FontAwesomeIcon
                                    icon={faArrowRight}
                                    aria-hidden="true"
                                />
                            </button>

                        </div>

                    </div>

                </div>

            )}

        </div>

    );
}
